import styled from "styled-components";

export const TextSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	width: 100%;
`;
